var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dashboard',{attrs:{"dashboard":_vm.pageValue.dashboard,"store-prefix":"template/"}})
}
var staticRenderFns = []

export { render, staticRenderFns }